import React from "react"
import styled, { css } from "styled-components"

const size = {
  tablet: 950,
  mobile: 600,
}

const above = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const Wrapper = styled.div``

const Container = styled.div`
  max-width: 856px;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 48px 24px 80px;
  /* ${above.mobile`
  padding:64px 48px 80px;
  `} */
  ${above.mobile`
padding-top: ${props => (props.pTop ? `${props.pTop}px` : "304px")};
padding-bottom: ${props => (props.pBottom ? `${props.pBottom}px` : "304px")};

padding-right:48px;
padding-left:48px;

  `}
  h1 {
    font-weight: 400;
    font-size: 48px;
    line-height: 56px;
    margin-bottom: 16px;
    ${above.mobile`
        font-size:64px;
        line-height:80px;
        margin-bottom:24px;
    `}
  }

  p {
    font-size: 18px;
    line-height: 32px;
    ${above.mobile`
    font-size:24px;
    
    `}
  }

  button {
    margin: 0 auto;
    cursor: pointer;
    background: transparent;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: var(--pacific-blue);
    padding: 12px 40px;
    border: 1px solid var(--pacific-blue);
    box-sizing: border-box;
    border-radius: 2px;

    &:hover {
      background: var(--arctic-blue);
      color: #b1d8fe;
    }
  }
`

function SuccessMessage({ setFormIsSubmitted }) {
  const wHeight = window ? window.innerHeight : null
  const pTop = 0.18 * wHeight
  const pBottom = 0.24 * wHeight
  return (
    <Wrapper>
      <Container pTop={pTop} pBottom={pBottom}>
        <h1>Thanks for reaching out!</h1>
        <p>
          Hang tight for now. One of our team members will be in touch with you
          soon!{" "}
        </p>
        <button onClick={() => setFormIsSubmitted(false)}>
          Send another message
        </button>
      </Container>
    </Wrapper>
  )
}

export default SuccessMessage
